import { Avatar, Button, Form, Input, message, Modal, Skeleton, Upload, UploadFile, UploadProps } from 'antd';
import { setUserPassword, updateUser, uploadProfilePicture } from '../../../api/user';
import ImgCrop from 'antd-img-crop';
import { useState } from 'react';
import { RcFile, UploadChangeParam } from 'antd/es/upload/index';
import { useGetUserFromAccessToken } from '../../../common/auth';
import { getUserInitials, getUserProfilePictureUrl } from '../../../common/userHelper';
import { CloseOutlined, LoadingOutlined, PlusOutlined, UserOutlined } from '@ant-design/icons';
import { useUpdateUserMutation } from '../../../serverState/user';
import { CustomSecondaryButton } from '../../../components/UI/CustomSecondaryButton';
import CustomInputLabel from '../../../components/UI/CustomInputLabel';
import { queryClient } from '../../../queryClient';
import CustomTooltip from '../../../components/UI/Tooltip/CustomTooltip';
import { DeleteAccountCard } from './DeleteAccountCard';
type updatePasswordFormStructure = {
  password: string;
  passwordConfirmation: string;
};

export default function MyProfile() {
  // Add UpdateProfileFormStructure to Form.useForm()
  const [editProfileForm] = Form.useForm<UpdateProfileFormStructure>();

  const [messageApi, contextHolder] = message.useMessage();

  const userFromAccessTokenQuery = useGetUserFromAccessToken();

  let user = userFromAccessTokenQuery.data;

  const [passwordForm] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [userHasPasswordConfigured, setUserHasPasswordConfigured] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [confirmLoadingSetPasswordModal, setConfirmLoadingSetPasswordModal] = useState(false);
  const [editProfileModalVisible, setEditProfileModalVisible] = useState(false);
  const [updateProfileModalConfirmLoading, setUpdateProfileModalConfirmLoading] = useState(false);
  console.log('user:', user);
  const [updatedProfilePic, setUpdatedProfilePic] = useState<{
    id: string | null;
    path: string | null;
  } | null>(null);

  const updatePassword = async (values: updatePasswordFormStructure) => {
    console.log(values);

    if (values.password !== values.passwordConfirmation) {
      console.log('Passwords do not match');
    }

    try {
      const res = await setUserPassword({
        password: values.password,
        passwordConfirmation: values.passwordConfirmation,
      });

      console.log(res);
    } catch (e) {
      console.log(e);
    }
  };

  const handleUpload = async (uploadRequest: unknown) => {
    const req = uploadRequest as { file: Blob; filename: string };
    console.log('uploadRequest', uploadRequest);
    if (!req.file || !req.filename) {
      return;
    }

    // setUploading(true);

    try {
      const uploadedPhoto = await uploadProfilePicture(req.file);
      setUpdatedProfilePic({
        id: uploadedPhoto.data.data.id,
        path: uploadedPhoto.data.data.path,
      });
      // setUploading(false);
      // Reload the page

      // TODO: fix this to not reload the page but load just temporarily
      // window.location.reload();
    } catch (e) {
      console.log(e);
    }
  };

  const handleSetPasswordModalOk = async () => {
    setConfirmLoadingSetPasswordModal(true);

    await updatePassword(passwordForm.getFieldsValue() as updatePasswordFormStructure);
    setConfirmLoadingSetPasswordModal(false);
    setShowPasswordModal(false);
  };

  const handleSetPasswordModalCancel = () => {
    setShowPasswordModal(false);
  };

  interface UpdateProfileFormStructure {
    fullName: string;
    email: string;
  }

  const onFinishUpdateProfile = async () => {
    // Get form values
    const formValues = editProfileForm.getFieldsValue();
    console.log(formValues);

    setUpdateProfileModalConfirmLoading(true);

    const emailChanged = formValues.email && formValues.email !== user?.user.email;
    const nameChanged = formValues.fullName !== user?.user.fullName;
    const profilePicChanged = updatedProfilePic?.id !== undefined && updatedProfilePic.id !== user?.user.profilePicture;

    console.log('profilePicChanged', profilePicChanged);
    try {
      let reqObject = {};
      // Call API to update profile name if name is different
      if (nameChanged) {
        reqObject = {
          fullName: formValues.fullName,
        };
      }

      if (emailChanged) {
        reqObject = {
          ...reqObject,
          email: formValues.email,
        };
      }

      if (profilePicChanged) {
        reqObject = {
          ...reqObject,
          profilePicture: updatedProfilePic.id,
          profilePicturePath: updatedProfilePic.path,
        };
      }

      if (nameChanged || emailChanged || profilePicChanged) {
        console.log('reqObject', reqObject);
        const updateUserObject = await updateUser(reqObject);

        // If name change was successful, update the user object
        if (updateUserObject && updateUserObject.status >= 200 && updateUserObject.status < 300) {
          await queryClient.invalidateQueries({
            queryKey: ['userFromAccessToken'],
          });
          user = userFromAccessTokenQuery.data;
          profilePic = getUserProfilePictureUrl(user?.user.profilePicturePath || null) || '';
          window.location.reload();
        }
      }
    } catch (e) {
      void message.error('Unable to update the name or the email. Please try again later.');
      console.log(e);
    }

    setUpdateProfileModalConfirmLoading(false);
    setEditProfileModalVisible(false);
  };

  const getBase64 = (img: RcFile, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result as string));
    reader.readAsDataURL(img);
  };

  const beforeUpload = (file: RcFile) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      void message.error('You can only upload JPG/PNG file!');
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      void message.error('Image must smaller than 10MB!');
    }
    return isJpgOrPng && isLt10M;
  };

  const handleChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in the real world.
      getBase64(info.file.originFileObj as RcFile, (url) => {
        setLoading(false);
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const getProfilePictureUrl = () => {
    if (user) {
      return getUserProfilePictureUrl(user.user.profilePicturePath);
    }
    return '';
  };

  let profilePic = getProfilePictureUrl();

  // TODO: use update user Mutation here
  const updateUserMutation = useUpdateUserMutation();

  return (
    <>
      {contextHolder}
      <div>
        <div className={'px-12 max-w-5xl mx-auto w-full'}>
          <div className="text-brand-grey-dark text-xl font-semibold leading-7 mb-6 mt-8">My profile</div>

          <div className="flex flex-col gap-6">
            <div className="rounded-lg border border-gray-300 p-4 border-solid custom-card">
              <div className="text-brand-grey-dark text-base font-semibold leading-normal">Personal Information</div>

              <div className={'flex items-center'}>
                {/* <img src={actualPath} /> */}
                <div className="profile-logo">
                  <Avatar className={'mr-2'} src={profilePic}>
                    {user?.user.fullName ? getUserInitials(user.user.fullName) : <UserOutlined />}
                  </Avatar>
                </div>
                <div className="profile-name-email pl-2 flex flex-col gap-1">
                  <div className="profile-name font-bold">{user ? user.user.fullName : <Skeleton />}</div>
                  <div className="profile-email">{user ? user.user.email : <Skeleton />}</div>
                </div>
                <div className="action-items grow align-middle flex justify-end">
                  <CustomSecondaryButton type="default" onClick={() => setEditProfileModalVisible(true)}>
                    Edit
                  </CustomSecondaryButton>
                </div>
              </div>
            </div>

            <div className="h-px bg-neutral-300 rounded-sm"></div>

            <div className="flex flex-col gap-3">
              <div className="flex">
                <div className="px-2 py-0.5 bg-red-100 rounded text-red-600 text-sm font-normal leading-5">Danger</div>
              </div>

              <DeleteAccountCard />
            </div>
          </div>
        </div>

        <Modal
          title={'Set or update your password'}
          open={showPasswordModal}
          onOk={handleSetPasswordModalOk}
          confirmLoading={confirmLoadingSetPasswordModal}
          onCancel={handleSetPasswordModalCancel}
          centered
        >
          <Form form={passwordForm} name={'passwordForm'} layout={'vertical'}>
            <Form.Item
              label={'New Password'}
              name={'password'}
              rules={[
                {
                  required: true,
                  message: 'Please input your new password!',
                },
              ]}
            >
              <Input type={'password'} />
            </Form.Item>

            <Form.Item
              label={'Password Confirmation'}
              name={'passwordConfirmation'}
              rules={[
                {
                  required: true,
                  message: 'Please input your new password!',
                },
              ]}
            >
              <Input type={'password'} />
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title={<div className="w-full text-center">Edit Personal Information</div>}
          open={editProfileModalVisible}
          onCancel={() => setEditProfileModalVisible(false)}
          footer={null}
          className=" max-w-[330px]"
          centered
        >
          <div className="flex flex-col items-stretch justify-around gap-8">
            <div
              // style={{
              //   width: 'min-content',
              //   margin: '0 auto',
              // }}
              className="flex justify-center items-center w-full mt-7"
            >
              <ImgCrop rotationSlider quality={1} zoomSlider>
                <Upload
                  name="profile-picture"
                  listType="picture-circle"
                  className="max-w-min"
                  showUploadList={false}
                  customRequest={handleUpload}
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                >
                  {(updatedProfilePic && updatedProfilePic.path !== null) || (!updatedProfilePic && profilePic) ? (
                    <div className="relative">
                      <div
                        className="absolute right-0 bottom-0 bg-gray-50 w-6 h-6 z-10 flex justify-center items-center"
                        style={{ borderRadius: '50%' }}
                        onClick={async (event) => {
                          event.stopPropagation();

                          setUpdatedProfilePic({ id: null, path: null });
                          // await updateUserMutation.mutateAsync(
                          //   {
                          //     // orgId: org?.id as number,
                          //     updatedFields: {
                          //       profilePicture: null,
                          //       profilePicturePath: null,
                          //     }
                          //   },
                          // );

                          // window.location.reload();
                        }}
                      >
                        <CustomTooltip title="Remove the image">
                          <CloseOutlined style={{ color: 'red' }} />
                        </CustomTooltip>
                      </div>
                      <Avatar
                        // className={'mr-2'}
                        // src={organizationLogo}
                        src={
                          updatedProfilePic && updatedProfilePic.path
                            ? getUserProfilePictureUrl(updatedProfilePic.path)
                            : profilePic
                        }
                        size={100}
                      >
                        {user?.user?.fullName ? user?.user.fullName.charAt(0) : <Skeleton />}
                      </Avatar>
                    </div>
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </ImgCrop>
            </div>

            <Form
              form={editProfileForm}
              name="editProfileForm"
              layout={'vertical'}
              initialValues={{
                fullName: user?.user.fullName,
                email: user?.user.email,
              }}
              onFinish={onFinishUpdateProfile}
            >
              <CustomInputLabel>Full Name</CustomInputLabel>
              <Form.Item
                name={'fullName'}
                rules={[
                  {
                    message: 'Please input your full name!',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <CustomInputLabel>Email</CustomInputLabel>
              <Form.Item
                name={'email'}
                rules={[
                  {
                    message: 'Please input your email!',
                    type: 'email',
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
              {/* <Form.Item> */}
              <div className="flex gap-3 w-full">
                <Button
                  type="default"
                  className="text-neutral-900 text-base font-semibold leading-tight ml-auto"
                  onClick={() => setEditProfileModalVisible(false)}
                >
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit" className="text-white text-base font-semibold leading-tight">
                  Save
                </Button>
              </div>

              {/* </Form.Item> */}
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
}
